import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { useLocation } from '@reach/router'

import { ContentProvider } from "../../context/contentProvider"
import { Header } from "./header"
import { Footer } from "./footer"

import './layout.css'
import './color.css'
import './display.css'
import './spacing.css'
import './fonts.css'; 
import './typography.css'
import './keyframes.css'
import './button.css'
import './position.css'
import './scrollspy.css'
import './form.css'
import { TranslateHeader } from "./header/translate-header"

const Layout = ({ children, isHeaderDark=false, languagePreference='English', languageToggle, languageSelected, setLanguage }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  const location = useLocation();
  const isDefaultHeader = !location.pathname.startsWith('/es');

  return (
    <ContentProvider>
      {/* Google Tag Manager (noscript) */}
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-5WXHFHS4"
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
          title="Google Tag Manager"
        ></iframe>
      </noscript>
      {/* End Google Tag Manager (noscript) */}
      {isDefaultHeader 
        ? <Header siteTitle={data.site.siteMetadata?.title || `Title`} isHeaderDark={isHeaderDark} languagePreference={languagePreference} languageToggle={languageToggle} languageSelected={languageSelected} setLanguage={setLanguage} /> 
          : <TranslateHeader isHeaderDark={isHeaderDark} languagePreference={languagePreference} languageSelected={languageSelected} languageToggle={languageToggle} />}
      
      <main>{children}</main>
      <Footer languagePreference={languagePreference} />
    </ContentProvider>
  )
}

export default Layout
